import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import PageHeader from "../components/layout/PageHeader";
import { Footer } from '../components/layout/Footer';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useHistory } from 'react-router-dom';

 const VerifyOtp = () => {
    const [validated, setValidated] = useState(false)
    const [otp, setOtp] = React.useState('')
    const history = useHistory()
    const auth=sessionStorage.getItem('user')
    useEffect( () => {
        if(auth){
            history.push(process.env.PUBLIC_URL+'/');
        }
    });
    const handleSubmit = (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false) {
        event.preventDefault()
        event.stopPropagation()
        }
        setValidated(true)
        const api_url=process.env.REACT_APP_API_URL
        if((otp !== '') ){
            const email=sessionStorage.getItem('fps');
            const formData = new FormData()
            formData.append("email",email)
            formData.append("otp",otp)
            const result=fetch(api_url + 'user/verify_change_password_otp', {
                method: 'POST',
                body: formData,
            })
            .then(response=>response.json())
            .then(result=> {
                if(result.status === true){
                    sessionStorage.setItem('fps',email);
                    alert(result.message+'!!')
                    history.push(process.env.PUBLIC_URL+'/change_password')
                }else{
                    alert(result.error+"!!")
                }
            })
        }else{
            alert('please enter valid OTP!!');
        }
    }
        return (
            <>
                <div className="site-main">
                    <Header/>
                
                    {/* PageHeader */} 
                    <PageHeader
                        title="Verify Your Account Details"
                        breadcrumb="OTP Verification"
                    />
                    {/* PageHeader end */}


                    {/* login */}
                    <div className="ttm-row login-section clearfix p-2">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 mx-auto">
                                    <div className="bg-theme-GreyColor ttm-col-bgcolor-yes ttm-bg rounded p-10 p-lg-20">
                                        <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                                        <div className="layer-content">
                                            <div className="ttm-tabs ttm-tab-style-02">
                                                <Tabs>
                                                    <TabList className="tabs">
                                                        <Tab className="tab">
                                                            <div style={{textAlign:'center'}}>
                                                            <img src={process.env.PUBLIC_URL+'/images/web/otp.png'} style={{height:'250px'}}/>
                                                            <p>We have sent an OTP on your email address</p>
                                                            </div>
                                                               
                                                        </Tab>
                                                    </TabList> 
                                                    <div className="content-tab">
                                                        <TabPanel>
                                                            <form id="login_form" className="login_form wrap-form">
                                                                <div className="row">
                                                                    <div className="col-lg-12">
                                                                        <label>
                                                                            <i className="ti ti-mobile"></i>
                                                                            <input type="number" id="txtemail" onChange={(e)=>{ setOtp(e.target.value);}} placeholder="Enter OTP here" />
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-lg-6 mx-auto">
                                                                        <label className="mb-0">
                                                                            <button className="submit w-100 ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor" type="button" onClick={handleSubmit}>Verify</button>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </TabPanel>
                                                    </div>       
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    {/* login end */}

                    
                <Footer/>
            </>
          )
   }

export default VerifyOtp;